const industries = [
  { icon: 'ri-tools-line', name: 'Manufacturing', desc: 'Zero tolerance for line downtime' },
  { icon: 'ri-heart-pulse-line', name: 'Medical', desc: 'HIPAA-compliant, always secure' },
  { icon: 'ri-tooth-line', name: 'Dental', desc: 'Patient data protection first' },
  { icon: 'ri-scales-3-line', name: 'Legal', desc: 'Privileged data, bulletproof backup' },
  { icon: 'ri-bank-line', name: 'Financial', desc: 'SOX, GLBA, PCI compliance-aware' },
  { icon: 'ri-briefcase-4-line', name: 'Professional Services', desc: 'Reliable IT, client-ready always' },
];

const Industries = () => {
  return (
    <section className="py-24 lg:py-32 bg-slate-900 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-700/60 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-700/60 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid lg:grid-cols-2 gap-16 xl:gap-24 items-center">

          {/* Left: header */}
          <div>
            <span className="text-teal-400 font-bold text-xs uppercase tracking-widest block mb-4">
              Who We Serve
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white leading-[1.05] tracking-tight mb-6">
              Built for Businesses With<br />
              <span className="text-slate-500">No Tolerance for Downtime</span>
            </h2>
            <p className="text-slate-500 text-base leading-relaxed max-w-sm mb-8">
              From regulated healthcare environments to high-velocity financial operations — we understand your compliance demands and uptime requirements.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-teal-500/50 flex-shrink-0" />
              <p className="text-slate-600 text-sm">
                Compliance-aware IT for regulated environments.
              </p>
            </div>
          </div>

          {/* Right: industry cards */}
          <div className="grid sm:grid-cols-2 gap-3">
            {industries.map((industry, i) => (
              <div
                key={i}
                className="group flex items-center gap-4 bg-slate-800/40 border border-slate-700/60 hover:border-teal-500/30 hover:bg-slate-800/70 rounded-xl px-5 py-4 transition-all duration-200 cursor-default"
              >
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-slate-700/60 group-hover:bg-teal-500/12 rounded-lg transition-colors duration-200">
                  <i className={`${industry.icon} text-base text-slate-500 group-hover:text-teal-400 transition-colors duration-200`} />
                </div>
                <div>
                  <p className="text-white font-bold text-sm leading-none mb-1">{industry.name}</p>
                  <p className="text-slate-600 text-xs leading-snug group-hover:text-slate-500 transition-colors">{industry.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
